/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportAppMessageViewRequest} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'
import {ReportAppMessageViewResponse} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'


export const reportAppMessageView = (request: ReportAppMessageViewRequest, options?: CashRequestOptions) => post<ReportAppMessageViewRequest, ReportAppMessageViewResponse>("/2.0/cash/report-app-message-view", request, {...options, rejectOnError: true })